// BAICalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import BAITable from "./BAITable";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Indeks Adipositas Tubuh";
const DESCRIPTION = " Gunakan kalkulator ini untuk menentukan Indeks Adipositas Tubuh (BAI) Anda secara akurat ";
const KEYWORDS = "BAI, kalkulator indeks obesitas, obesitas, indeks obesitas";
const OG_URL = "https://do-calculate.com/calculator/id/bai-calculator/";
function BAIcalculator() {
  const [height, setHeight] = useState();
  const [hipCircumference, setHipCircumference] = useState();
  const [gender, setGender] = useState("male");
  const [age, setAge] = useState();
  const [result, setResult] = useState();
  const [classification, setClassification] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      setError("");
      setResult("");
      if (age < 20) {
        setError("Indeks Adipositas Tubuh ditujukan untuk usia di atas 20 tahun");
        return;
      }
      const heightInMeters = height / 100;
      const BAI = hipCircumference / Math.pow(heightInMeters, 1.5) - 18;
      setResult(BAI.toFixed(2));
      if (gender === "female") {
        if (age >= 20 && age <= 39) {
          if (BAI < 21) setClassification("Underweight");
          else if (BAI >= 21 && BAI <= 33) setClassification("Healthy");
          else if (BAI > 33 && BAI <= 39) setClassification("Overweight");
          else if (BAI > 39) setClassification("Obese");
        } else if (age >= 40 && age <= 59) {
          if (BAI < 23) setClassification("Underweight");
          else if (BAI >= 23 && BAI <= 35) setClassification("Healthy");
          else if (BAI > 35 && BAI <= 41) setClassification("Overweight");
          else if (BAI > 41) setClassification("Obese");
        } else if (age >= 60 && age <= 79) {
          if (BAI < 25) setClassification("Underweight");
          else if (BAI >= 25 && BAI <= 38) setClassification("Healthy");
          else if (BAI > 38 && BAI <= 43) setClassification("Overweight");
          else if (BAI > 43) setClassification("Obese");
        }
      } else if (gender === "male") {
        if (age >= 20 && age <= 39) {
          if (BAI < 8) setClassification("Underweight");
          else if (BAI >= 8 && BAI <= 21) setClassification("Healthy");
          else if (BAI > 21 && BAI <= 26) setClassification("Overweight");
          else if (BAI > 26) setClassification("Obese");
        } else if (age >= 40 && age <= 59) {
          if (BAI < 11) setClassification("Underweight");
          else if (BAI >= 11 && BAI <= 23) setClassification("Healthy");
          else if (BAI > 23 && BAI <= 29) setClassification("Overweight");
          else if (BAI > 29) setClassification("Obese");
        } else if (age >= 60 && age <= 79) {
          if (BAI < 13) setClassification("Underweight");
          else if (BAI >= 13 && BAI <= 25) setClassification("Healthy");
          else if (BAI > 25 && BAI <= 31) setClassification("Overweight");
          else if (BAI > 31) setClassification("Obese");
        }
      }
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Hitung Indeks Adipositas Tubuh (BAI) dengan akurat dan mudah! Dengan kalkulator canggih kami, Anda dapat menentukan Indeks Adipositas Tubuh (BAI) secara akurat dalam hitungan detik. Cukup masukkan pengukuran sederhana seperti lingkar pinggul dan tinggi badan, dan Anda akan mendapatkan hasil instan dan terperinci. Kalkulator ini dikembangkan berdasarkan penelitian ilmiah terbaru di bidang pengukuran lemak tubuh, memastikan akurasi dan keandalan hasil.
                </p>
                <p>
                  Mengapa indeks BAI penting? Indeks Adipositas Tubuh (BAI) adalah ukuran yang lebih akurat untuk memperkirakan persentase lemak tubuh dibandingkan dengan Indeks Massa Tubuh (BMI) tradisional, terutama bagi mereka yang mengalami obesitas atau kekurangan berat badan. Mengetahui BAI Anda membantu Anda melacak kemajuan Anda menuju dan mempertahankan berat badan yang sehat, serta membuat keputusan berdasarkan informasi tentang diet dan olahraga Anda.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div >
                  <div>
                    <hr />
                    <div className="form-groupitems-center">
                      <label className="form-label ms-2" htmlFor="age">
                        Masukkan usia
                      </label>
                      <input
                        id="age"
                        type="number"
                        value={age}
                        onChange={(e) => setAge(e.target.value)}
                        placeholder="Masukkan usia"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group items-center">
                      <label className="form-label ms-2" htmlFor="gender">
                        Pilih jenis kelamin
                      </label>
                      <select
                        id="gender"
                        value={gender}
                        onChange={(e) => setGender(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="male">Laki-laki</option>
                        <option value="female">Perempuan</option>
                      </select>
                    </div>
                    <div className="form-group items-center">
                      <label className="form-label ms-2" htmlFor="height">
                        Masukkan tinggi badan
                      </label>
                      <div
                        className="d-flex"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          id="height"
                          type="number"
                          value={height}
                          onChange={(e) => setHeight(e.target.value)}
                          placeholder="Masukkan tinggi badan"
                          className="form-control"
                          style={{ width: "75%" }}
                        />
                        <span className="input-group-text ">cm</span>
                      </div>
                    </div>
                    <div className="form-group items-center">
                      <label
                        className="form-label ms-2"
                        htmlFor="hipCircumference"
                      >
                        Masukkan lingkar pinggul
                      </label>
                      <div
                        className="d-flex"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          id="hipCircumference"
                          type="number"
                          value={hipCircumference}
                          onChange={(e) => setHipCircumference(e.target.value)}
                          placeholder="Masukkan lingkar pinggul"
                          className="form-control"
                          style={{ width: "75%" }}
                        />
                        <span className="input-group-text ">cm</span>
                      </div>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Hitung
                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Error: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Hasil:</h4>
                      <p className="text-white">{result}</p>
                      <p className="text-white">
                        {classification === "Underweight"
                          ? "Kekurangan Berat Badan"
                          : classification === "Healthy"
                          ? "Berat Badan Sehat"
                          : classification === "Overweight"
                          ? "Kelebihan Berat Badan"
                          : classification === "Obese"
                          ? "Obesitas"
                          : ""}
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
              <div className="col-sm-12 col-md-5">
                {gender === "female" && (
                  <BAITable classification={classification} gender="female" />
                )}
                {gender === "male" && (
                  <BAITable classification={classification} gender="male" />
                )}
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Cara Menggunakan Kalkulator</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Langkah Penggunaan</h2>
                  </u>
                  <p>1. Masukkan usia dan jenis kelamin.</p>
                  <p>2. Masukkan tinggi badan dan lingkar pinggul.</p>
                  <p>3. Klik tombol "Hitung".</p>
                  <div className="p-3 mb-2 bg-info ">
                    Contoh: Jika tinggi Anda 170 cm dan lingkar pinggul 100 cm, maka BAI Anda adalah X.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Informasi Tambahan</h2>
                  </u>
                  <p>
                    Indeks Adipositas Tubuh (BAI) digunakan untuk memperkirakan persentase lemak tubuh.
                  </p>
                  <p>
                    Berbeda dengan Indeks Massa Tubuh (BMI) karena mempertimbangkan distribusi lemak tubuh.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default BAIcalculator;